import React, { createContext, useContext } from 'react';

const IsSidebarOpenContext = createContext(false);

interface IsSidebarOpenProviderProps {
  isSidebarOpen: boolean;
  children: React.ReactNode;
}

export const IsSidebarOpenProvider = ({
  children,
  isSidebarOpen,
}: IsSidebarOpenProviderProps) => {
  return (
    <IsSidebarOpenContext.Provider value={isSidebarOpen}>
      {children}
    </IsSidebarOpenContext.Provider>
  );
};

export const useIsSidebarOpen = () => useContext(IsSidebarOpenContext);
